import { DocumentV2 } from '@eigtech/documents-types'

export function sortDocumentsByDate(a: DocumentV2, b: DocumentV2) {
  return (
    new Date(b.modifiedDate ?? b.createdDate ?? new Date().toISOString()).getTime() -
    new Date(a.modifiedDate ?? a.createdDate ?? new Date().toISOString()).getTime()
  )
}

export function sortDocumentsByType(type: string) {
  return function sortDocumentsByType(a: DocumentV2, b: DocumentV2) {
    const aIsProbablyType = a.filename.toLowerCase().includes(type)
    const bIsProbablyType = b.filename.toLowerCase().includes(type)

    return Number(bIsProbablyType) - Number(aIsProbablyType)
  }
}
